<template>
  <section id="info">
    <div class="container">
      <!--   Icon Section   -->
      <div class="row">
        <div class="col s12 m4">
          <div class="icon-block">
            <h2 class="center green-text text-darken-3">
              <i class="far fa-square"></i>
            </h2>
            <h5 class="center">Fast fast fast squares</h5>

            <p class="light">
              Lighten the burden of organizing a squares pool. Supersquares
              shows free spaces, allows random selection and highlights each
              winner
            </p>
          </div>
        </div>

        <div class="col s12 m4">
          <div class="icon-block">
            <h2 class="center green-text text-darken-3">
              <i class="fas fa-user-plus"></i>
            </h2>
            <h5 class="center">Invite your friends</h5>

            <p class="light">
              Remote folks? No problem! Shoot a link to your supersquares sheet
              and they can pick their squares without annoying phone calls or
              trading emails about who wants what.
            </p>
          </div>
        </div>

        <div class="col s12 m4">
          <div class="icon-block">
            <h2 class="center green-text text-darken-3">
              <i class="fas fa-cogs"></i>
            </h2>
            <h5 class="center">Setup in three easy steps.</h5>

            <p class="light">
              Pick a game, choose your squares & create your numbers. Then just
              kick back and wait for the big game to start!
            </p>
          </div>
        </div>
      </div>

      <br />
      <br />
    </div>
  </section>
</template>

<script>
export default {}
</script>

<style>
</style>
